import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

/**
 * Fetch all lineup submissions for a specific league and event
 * Returns array of submissions with user info and lineup data
 */
const fetchLeagueMemberSubmissions = async (
  leagueId,
  eventId,
  getAccessTokenSilently,
) => {
  const token = await getAccessTokenSilently();
  const apiUrl = process.env.REACT_APP_API_URL;

  const { data } = await axios.get(
    `${apiUrl}/api/lineup/${leagueId}/${eventId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return data;
};

export const useFetchLeagueMemberSubmissions = (leagueId, eventId) => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery(
    ["leagueMemberSubmissions", leagueId, eventId],
    () =>
      fetchLeagueMemberSubmissions(leagueId, eventId, getAccessTokenSilently),
    {
      enabled: !!leagueId && !!eventId,
      staleTime: 30000, // 30 seconds
      refetchOnWindowFocus: false, // Prevent refetch on window focus to reduce flickering
      keepPreviousData: true, // Keep previous data while loading new selection
    },
  );
};
